import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RoutingState } from './RoutingState';

export type AppLang = 'en' | 'ar';

@Injectable({ providedIn: 'root' })
export class LanguageService {

    private readonly STORAGE_KEY = 'app_lang';

    constructor(
        private translate: TranslateService,
        private routingState: RoutingState) { }

    init(): void {
        const savedLang = (localStorage.getItem(this.STORAGE_KEY) as AppLang) || 'en';
        this.use(savedLang);
    }

    use(lang: AppLang): void {
        this.translate.use(lang).subscribe(() => {
            this.routingState.loadOne();
        });
        localStorage.setItem(this.STORAGE_KEY, lang);

        // RTL handling
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = lang;
    }

    get current(): AppLang {
        return (this.translate.currentLang as AppLang) || 'en';
    }
}